import { settleWriteToolPartWithOutput } from "@/components/assistant/settleWriteToolPartWithOutput";
import type { UIMessage } from "ai";

type DirectWriteConfig = {
  entityKey: string;
  isWriteToolName: (toolName: string) => boolean;
  buildOutput: (entity: Record<string, unknown>) => Record<string, unknown>;
};

export async function parseWriteAssistantApproveResponse({
  response,
  path,
  requestMessages,
  settledToolCallId,
  directWrite,
}: {
  response: Response;
  path: "approve" | "decline";
  requestMessages: UIMessage[];
  settledToolCallId: string;
  directWrite?: DirectWriteConfig;
}): Promise<{ nextMessages: UIMessage[]; handledAsJson: boolean }> {
  const contentType = response.headers.get("content-type") ?? "";

  if (contentType.includes("application/json")) {
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || `Request failed (${response.status})`);
    }
    const data = (await response.json()) as Record<string, unknown>;
    if (
      path === "approve" &&
      data.directWrite === true &&
      directWrite &&
      settledToolCallId &&
      data[directWrite.entityKey] &&
      typeof data[directWrite.entityKey] === "object"
    ) {
      const entity = data[directWrite.entityKey] as Record<string, unknown>;
      const nextMessages = settleWriteToolPartWithOutput({
        messages: requestMessages,
        toolCallId: settledToolCallId,
        isWriteToolName: directWrite.isWriteToolName,
        output: directWrite.buildOutput(entity),
      });
      return { nextMessages, handledAsJson: true };
    }
    return { nextMessages: requestMessages, handledAsJson: true };
  }

  return { nextMessages: requestMessages, handledAsJson: false };
}
